import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import { componentRef } from './consts';

export default grapesjs.plugins.add('gjs-pdf-viewer', (editor, opts) => {
  let options = opts || {};

  let defaults = {
    pfx: 'pdf-viewer',
    blocks: [componentRef],
    defaultStyle: true,
    labelTable: 'PDF Viewer',
    labelPDFViewerCategory: 'Advanced',
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }
  loadComponents(editor, options);
  loadBlocks(editor, options);
});
